import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { SnapshotThreshold } from 'types';

export const clearThresholds = ({ snapshotId }: { snapshotId: number }) => {
  return axios.delete(`/api/snapshots/${snapshotId}/thresholds/clear`);
};

type UseClearThresholdsOptions = {
  snapshotId: number;
  config?: MutationConfig<typeof clearThresholds>;
};

export const useClearThresholds = ({
  config,
  snapshotId,
}: UseClearThresholdsOptions) => {
  return useMutation({
    onMutate: async () => {
      await queryClient.cancelQueries(['snapshot', snapshotId, 'thresholds']);

      const previousThresholds = queryClient.getQueryData<SnapshotThreshold[]>([
        'snapshot',
        snapshotId,
        'thresholds',
      ]);

      queryClient.setQueryData(['snapshot', snapshotId, 'thresholds'], []);

      return { previousThresholds };
    },
    onError: (_, __, context: any) => {
      if (context?.previousThresholds) {
        queryClient.setQueryData(
          ['snapshot', snapshotId, 'thresholds'],
          context.previousThresholds
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['snapshot', snapshotId]);
    },
    ...config,
    mutationFn: clearThresholds,
  });
};
